import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  pageWrapper: {
    height: "100vh",
    display: "flex",
    overflow: "hidden",
  },
  sideBar: {
    width: 60,
    flexShrink: 0,
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      left: 0,
      top: 0,
      bottom: 0,
      width: "100%",
      height: "60px",
    },
  },
  loginPage: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    paddingLeft: "0px",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
      paddingTop: "0px",
    },
  },
  mainContent: {
    width: "calc(100% - 60px)",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
      paddingTop: "70px",
    },
  },
  appBar: {
    height: 60,
    flexShrink: 0,
    display: "flex",
  },
  pageContent: {
    flex: 1,
    height: "calc(100% - 60px)",
  },
}))

export default styles
